import React from 'react';
import { graphql } from 'gatsby';
import Layout from '../components/layout';
import CollectionBasic from '../components/collection-components/collection-basic';
import SEO from '../components/seo';

const CollectionBasicTemplate = ({ data }) => {
    const collection = data.collectionsNode.edges[0].node;
    const wpContent =
        (data.wordpress_content.edges[0] &&
            data.wordpress_content.edges[0].node) ||
        null;
    return (
        <Layout>
            <SEO title={collection.title} />
            <CollectionBasic collection={collection} assets={wpContent} />
        </Layout>
    );
};

export default CollectionBasicTemplate;

export const query = graphql`
    query($handle: String!) {
        collectionsNode: allShopifyCollection(
            filter: { handle: { eq: $handle } }
        ) {
            edges {
                node {
                    title
                    products {
                        options {
                            name
                            values
                        }
                        availableForSale
                        priceRange {
                            maxVariantPrice {
                                amount
                            }
                        }
                        handle
                        images {
                            id
                            altText
                            localFile {
                                childImageSharp {
                                    fluid(maxWidth: 500) {
                                        ...GatsbyImageSharpFluid
                                    }
                                }
                            }
                        }
                        productType
                        shopifyId
                        tags
                        title
                        variants {
                            compareAtPrice
                            availableForSale
                            price
                            selectedOptions {
                                name
                                value
                            }
                            shopifyId
                            image {
                                altText
                                localFile {
                                    childImageSharp {
                                        fluid(maxWidth: 700) {
                                            ...GatsbyImageSharpFluid
                                        }
                                    }
                                }
                            }
                        }
                    }
                }
            }
        }
        wordpress_content: allWpCollection(filter: { slug: { eq: $handle } }) {
            edges {
                node {
                    id
                    title
                    slug
                    collection_acf {
                        desktopBannerImage {
                            localFile {
                                childImageSharp {
                                    fluid(maxWidth: 1920) {
                                        ...GatsbyImageSharpFluid
                                    }
                                }
                            }
                        }
                        collectionLayout
                        collectionBannerBlurb
                        collectionGridTopText
                        collectionGridPromo1 {
                            promoColor
                            promoPosition
                            promoLink {
                                title
                                url
                            }
                            promoImage {
                                localFile {
                                    childImageSharp {
                                        fluid(maxWidth: 600) {
                                            ...GatsbyImageSharpFluid
                                        }
                                    }
                                }
                            }
                        }
                        collectionGridPromo2 {
                            promoColor
                            promoPosition
                            promoLink {
                                title
                                url
                            }
                            promoImage {
                                localFile {
                                    childImageSharp {
                                        fluid(maxWidth: 600) {
                                            ...GatsbyImageSharpFluid
                                        }
                                    }
                                }
                            }
                        }
                        collectionSplitSection {
                            splitSectionIcons {
                                iconImage {
                                    localFile {
                                        childImageSharp {
                                            fluid(maxWidth: 1000) {
                                                ...GatsbyImageSharpFluid
                                            }
                                        }
                                    }
                                }
                                iconBlurb
                                iconTitle
                            }
                            splitSectionButton {
                                title
                                url
                            }
                            splitSectionTitle
                            splitSectionCaption
                            splitSectionImage {
                                localFile {
                                    childImageSharp {
                                        fluid(maxWidth: 1000) {
                                            ...GatsbyImageSharpFluid
                                        }
                                    }
                                }
                            }
                        }
                        collectionVideoSettings {
                            videoImage {
                                localFile {
                                    childImageSharp {
                                        fluid(maxWidth: 1000) {
                                            ...GatsbyImageSharpFluid
                                        }
                                    }
                                }
                            }
                            videoCaption
                            videoSource
                            videoTitle
                            videoLinkText
                        }
                        collectionContentRowSettings {
                            collectionContentRows {
                                contentRowDescription
                                contentRowTitle
                                contentRowImage {
                                    localFile {
                                        childImageSharp {
                                            fluid(maxWidth: 1000) {
                                                ...GatsbyImageSharpFluid
                                            }
                                        }
                                    }
                                }
                            }
                            collectionDescription
                            collectionDescriptionTitle
                        }
                        contentTilesSettings {
                            contentTiles {
                                tileLink {
                                    title
                                    url
                                }
                                tileHoverColor
                                tileShortDescription
                                tileImage {
                                    localFile {
                                        childImageSharp {
                                            fluid(maxWidth: 600) {
                                                ...GatsbyImageSharpFluid
                                            }
                                        }
                                    }
                                }
                            }
                        }
                        collectionBottomWaveSettings {
                            waveCaption
                            waveTitle
                            waveButton {
                                target
                                title
                                url
                            }
                        }
                        collectionBlogFeed {
                            blogCategoryHandle
                            sectionTitle
                        }
                    }
                }
            }
        }
    }
`;
